import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { InboxOutlined, LoadingOutlined } from "@ant-design/icons";
import { HiOutlineDownload } from "react-icons/hi";
import { message, Spin, Upload } from "antd";
import * as XLSX from "xlsx";

import "./styles.scss";
import uris from "../../../config/uris";
import Breadcrumbs from "../../../assets/component/breadcrumbs";
import {
  uploadEntities,
  uploadEntitiesReset,
} from "../../../store/slices/entities/uploadEntities";


const menuData = {
  title: "Entities",
  parentMenu: {
    name: "Entities",
  },
  subMenu: {
    name: "Upload Entity",
    link: uris?.uploadEntities,
  },
};

const UploadEntities = () => {
  const [files, setFiles] = useState(null);
  const [fileList, setFileList] = useState([]);

  const dispatch = useDispatch();

  const {
    error: uploadEntitiesError,
    data: uploadEntitiesData,
    success: uploadEntitiesSuccess,
    isLoading: uploadEntitiesLoading,
  } = useSelector((state) => state?.uploadEntities);

  const { Dragger } = Upload;

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 18, color: "white" }} spin />
  );

  const validateFile = (file) => {
    const isValidType =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel" ||
      file.type === "text/csv";
    const isLt3M = file.size / 1024 / 1024 <= 3;

    if (!isValidType) {
      message.error("Please upload only Excel or CSV files!");
      return false;
    }
    if (!isLt3M) {
      message.error("File must be smaller than 3MB!");
      return false;
    }
    return true;
  };
  
  const props = {
    name: "file",
    maxCount: 1,
    accept: ".xlsx,.xls,.csv",
    fileList,
    beforeUpload: (file) => {
      if (!validateFile(file)) {
        return Upload.LIST_IGNORE;
      }
      setFiles(file);
      setFileList([file])
      return false;
    },

    onDrop: (e) => {
      const droppedFile = e.dataTransfer.files[0];
      if (validateFile(droppedFile)) {
        setFiles(droppedFile);
        setFileList([droppedFile])
      }
    },
    onRemove: () => {
      setFiles(null);
      setFileList([]);
    },
  };

  const handleDownloadTemplate = () => {
    const headers = [
      "Name",
      "Region",
      "Country Name",
      "Country Code",
      "Industry",
      "Investor Name",
      "Security ID",
      "Target Company ID",
      "Source Company ID",
      "Types"
    ];
    const rowData = [
      "ZOZO Inc",
      "East Asia & Pacific",
      "Japan",
      "JP",
      "Internet & Direct Marketing Retail",
      "ZOZO",
      "4295875926",
      "67761678c345d8b6e93bdc97,6746c3eeeae35088ca523dae",
      "63e134f8756b07bb3235726e,63e134f1756b07bb32354aea",
      "Company,Investor,Fund"
    ];

    const data = [headers, rowData];
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "Entities_Upload_Template.xlsx");
  };

  const handleSubmit = () => {
    if (!files) {
      message.error("Please upload a file before submitting.");
      return;
    }
    let payload = new FormData();
    payload.append("file", files);

    dispatch(uploadEntities(payload));
  };

  useEffect(() => {
    if (uploadEntitiesSuccess) {
      message.success(uploadEntitiesData?.message);
      dispatch(uploadEntitiesReset());
      setFiles(null);
      setFileList([]);
    }
    if (uploadEntitiesError) {
      message.error(uploadEntitiesError?.message);
      dispatch(uploadEntitiesReset());
      }
  }, [uploadEntitiesSuccess, uploadEntitiesError]);

  return (
    <div className="entity-main-container">
      <Breadcrumbs breadcrumbDetails={menuData} />
      <div className="header-container">
        <div
          className="button-wrapper template"
          onClick={handleDownloadTemplate}
        >
          <HiOutlineDownload />
          Template
        </div>
      </div>
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">Accepts only Excel or CSV file</p>
      </Dragger>
      {uploadEntitiesLoading ? (
        <div className="button-wrapper loader">
          {" "}
          <Spin indicator={antIcon} />{" "}
        </div>
      ) : (
        <div className="button-wrapper submit" onClick={handleSubmit}>
          {" "}
          Submit{" "}
        </div>
      )}
    </div>
  );
};

export default UploadEntities;
